import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import AsYouType, {
  getCountryCallingCode,
} from "libphonenumber-js";
import {
  COUNTRY_PHONE_CODE,
  // ACCOUNT_TYPES,
  // INDIA_ACCOUNT_TYPES,
  // BENETYPES,
  EMAIL,
  BUSINESS_TYPES_FUNDINGlINK,
} from "../../../appconstants";
import {
  H2Text,
  LabelText,
  SpanText,
  Text,
  Input,
  InputWrapper,
  Hr,
} from "../../../design";
import {
  Row,
  Col,
  Alert,
} from 'antd';
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';
import AddressFields from "./AddressFields";
import IndiaFields from "./IndiaFields";
import { formatToE164 } from "../../../utils/formatToE164";

type Props = {
  errors: Object,
  control: Object,
  errorMsg: String,
  watch: Function,
  trigger: Function,
  register: Function,
  setValue: Function,
  preFillCustomer: Object,
  customerDisabled: Boolean,
  customerValidation: Boolean,
  setShowErrorMessage: Function,
  otherFields: Array,
  alpha2: String,
  isMobileView: Boolean,
  customH2TextStyle: Object,
  customLabelTextStyle: Object,
  plaidContactInfo: String,
  plaidPublicToken: String,
  accountName: String,
  contactType: String,
};

const CommonFields = (props: Props) => {
  const {
    errors,
    control,
    errorMsg,
    watch,
    trigger,
    register,
    setValue,
    preFillCustomer,
    customerDisabled,
    customerValidation,
    setShowErrorMessage,
    alpha2,
    isMobileView,
    customH2TextStyle,
    customLabelTextStyle,
    plaidPublicToken,
    plaidContactInfo,
    accountName,
    contactType,
  } = props;

  const BACKGROUND_COLOR = '#f5f5f5';
  const COLOR = '#b8b8b8';
  const isUSAndVerified = alpha2 === 'US' && plaidPublicToken;
  const isFBOReceiver = (contactType || preFillCustomer?.contactType) === 'FBO_RECEIVER';

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = (phone && `+${phone.countryCallingCode}`) || (alpha2 && `+${getCountryCallingCode(alpha2)}`);
      setValue('name', (preFillCustomer && preFillCustomer?.name) || '');
      setValue('email', (preFillCustomer && preFillCustomer?.email) || '');
      setValue('phone', (phone && phone?.nationalNumber) || '');
      setValue('countryCallingCode', (countryCallingCode && findCountryCallingCode(countryCallingCode)) || '');
      setValue('isDefault', false);
      if (isFBOReceiver) {
        setValue('receiptLimit', null);
      }
    }
  }, [preFillCustomer, setValue, alpha2, isFBOReceiver]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const isPhoneNumberValidate = (data) => {
    const countryCode = control?.getValues()?.countryCallingCode?.value;
    const phoneNum = control?.getValues()?.phone;
    if(!isValidPhoneNumber(`${countryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };

  const contructPlainContactInfoAddress = (address) => {
    const { street, city, region, postalCode, country } = address || {};
    const regionPostal = [region, postalCode].filter(Boolean).join(' ');
    return [street, city, regionPostal, country].filter(Boolean).join(', ');
  };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  }

  const selectCustomStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: 33,
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    }),
  };

  const disableStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      // width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      background: '#f5f5f5',
      color: '#b8b8b8'
    }),
  };

  const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
      // maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
  };

  const selectionBoxStyle = (isSelected) => ({
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${isSelected ? '#40A9FF' : '#E5E7EB'}`,
    borderRadius: '8px',
    padding: '12px 16px',
    marginBottom: '8px',
    cursor: 'pointer',
    backgroundColor: '#FFFFFF',
  });

  return (
  <>
    {isUSAndVerified && plaidContactInfo && (
      <div className="plaid-verified-contact-details">
        {Array.isArray(plaidContactInfo?.emails) && plaidContactInfo?.emails?.length > 0 && (
          <Row>
            <Col span={24}>
              <H2Text {...customH2TextStyle} style={{ marginTop: '20px', marginBottom: '15px' }}>
                EMAIL ADDRESSES
              </H2Text>
              <Controller
                name="selectedEmail"
                control={control}
                rules={{ required: "Please select an email address" }}
                render={({ onChange, value }) => (
                  <div>
                    {plaidContactInfo?.emails?.map((email, index) => (
                      <label key={index} style={selectionBoxStyle(value === email?.data)}>
                        <input
                          type="radio"
                          value={email?.data}
                          checked={value === email.data}
                          onChange={(e) => onChange(e.target.value)}
                          style={{ marginRight: '16px', cursor: 'pointer' }}
                        />
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ color: value === email?.data ? '#40A9FF' : '#6B7280' }}>
                            {email?.type}
                          </span>
                          <span style={{ color: value === email?.data ? '#40A9FF' : '#9CA3AF' }}>
                            {email?.data}
                          </span>
                        </div>
                      </label>
                    ))}
                  </div>
                )}
              />
              <ErrorMessage errors={errors} name="selectedEmail" render={({ message }) => (<Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>)}/>
            </Col>
          </Row>
        )}
        {Array.isArray(plaidContactInfo?.phoneNumbers) && plaidContactInfo?.phoneNumbers?.length > 0 && (
          <Row>
            <Col span={24}>
              <H2Text {...customH2TextStyle} style={{ marginTop: '30px', marginBottom: '15px' }}>
                PHONE NUMBERS
              </H2Text>
              <Controller
                name="selectedPhone"
                control={control}
                rules={{ required: "Please select a phone number" }}
                defaultValue=""
                render={({ onChange, value }) => (
                  <div>
                    {plaidContactInfo?.phoneNumbers?.map((phone) => {
                      const formattedPhone = formatToE164(phone?.data, '+1', phone?.data ? (phone.data.startsWith('+') ? phone.data : `+${phone.data}`) : '')
                      return (
                        <label key={phone?.id} style={selectionBoxStyle(value === formattedPhone)}>
                          <input
                            type="radio"
                            value={formattedPhone}
                            checked={value === formattedPhone}
                            onChange={(e) => onChange(e.target.value)}
                            style={{ marginRight: '16px', cursor: 'pointer' }}
                          />
                          <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ color: value === formattedPhone ? '#40A9FF' : '#6B7280' }}>
                              {phone?.type}
                            </span>
                            <span style={{ color: value === formattedPhone ? '#40A9FF' : '#9CA3AF' }}>
                              {formattedPhone}
                            </span>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                )}
              />
              <ErrorMessage errors={errors} name="selectedPhone" render={({ message }) => (<Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>)}/>
            </Col>
          </Row>
        )}
        {plaidContactInfo?.address?.street && (
          <Row>
            <Col span={24}>
              <H2Text {...customH2TextStyle} style={{ marginTop: '30px', marginBottom: '15px' }}>
                ADDRESS
              </H2Text>
              <Text
                fontSize="16px"
                marginTop="8px"
                marginBottom="0px"
                color="#4A5565"
              >
                {contructPlainContactInfoAddress(plaidContactInfo.address)}
              </Text>
            </Col>
          </Row>
        )}
        {(watch().selectedEmail || watch().selectedPhone) && (
           <Row className="mt-4">
              <Col span={24}>
                <Alert
                  message={
                    <>
                      An OTP will be sent to 
                      {watch().selectedEmail && <strong> {watch().selectedEmail}</strong>}
                      {watch().selectedEmail && watch().selectedPhone && " and/or "}
                      {watch().selectedPhone && <strong> +1{watch().selectedPhone}</strong>}
                      {" to securely authorize your transfers."}
                    </>
                  }
                  type="warning"
                  showIcon
                />
              </Col>
            </Row>
        )}
        <Text
          fontSize="16px"
          marginTop="20px"
          marginBottom="0px"
          color="#4A5565"
          lineHeight="1.4"
        >
          {`By clicking Submit, you authorize ${accountName || '-'} to use the linked funding source to
          initiate transfers on your behalf and to use your verified contact information
          for identity verification and compliance purposes.`}
        </Text>
      </div>
    )}
    <div style={{ display: isUSAndVerified ? 'none' : 'block' }}>
      <Row>
        <Col span={24}>
          <H2Text
            {...customH2TextStyle}
          >
            YOUR CONTACT DETAILS
          </H2Text>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={isMobileView ? 24 : 12}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            Name
          </LabelText>
          <Controller
            defaultValue={""}
            color={errors.name ? "red" : "inherit"}
            marginBottom="0px"
            control={control}
            name="name"
            placeholder="Enter your name"
            rules={customerValidation && {
              required: 'This field is required'
            }}
            as={<Input
              readOnly={customerDisabled}
              style={{
                ...customInputStyle,
                background: customerDisabled ? BACKGROUND_COLOR : '',
              }}
            />}
          />
          <ErrorMessage
            errors={errors}
            name="name"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
        <Col span={isMobileView ? 24 : 12}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            E-Mail
          </LabelText>
          <Controller
            marginBottom="0px"
            defaultValue={""}
            color={errors.email ? "red" : "inherit"}
            control={control}
            name="email"
            placeholder="Enter your email address"
            rules={customerValidation && {
              required: 'This field is required',
              pattern: {
                value: EMAIL.DEFAULT_REGEX,
                message: 'The email is invalid',
              },
            }}
            as={<Input
              readOnly={customerDisabled}
              style={{
                ...customInputStyle,
                background: customerDisabled ? BACKGROUND_COLOR : ''
              }}
            />}
          />
          <ErrorMessage
            errors={errors}
            name="email"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={isMobileView ? 24 : 12}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            Phone
          </LabelText>
          <InputWrapper
            className="row"
            display="flex"
            marginTop="8px"
            style={{
              ...customInputStyle,
              paddingLeft: 0,
            }}
          >
            <Controller
              defaultValue={""}
              color={errors.countryCallingCode ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="countryCallingCode"
              placeholder="select"
              rules={customerValidation && {
                required: 'Calling Code is required'
              }}
              as={<Select
                className="col-4 px-0 border-0"
                menuPlacement="auto"
                isSearchable={!customerDisabled}
                menuIsOpen={customerDisabled ? false : undefined}
                theme={theme => ({
                  ...theme,
                  borderRadius: "4px 0 0 4px",
                  boxShadow: 0
                })}
                getOptionLabel={(option) => option.value}
                styles={customerDisabled ? disableStyles : phoneCustomStyles}
                options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
            />
            <Controller
              className="col"
              defaultValue={""}
              color={errors.phone ? "red" : "inherit"}
              border="0px !important"
              marginBottom="0px"
              marginTop="0px"
              marginLeft="0px"
              paddingRight="0"
              control={control}
              name="phone"
              rules={customerValidation && {
                required: 'This field is required',
                validate: isPhoneNumberValidate
              }}
              as={<NumberFormat
                type="tel"
                allowNegative={false}
                decimalScale={0}
                readOnly={customerDisabled}
                borderRadius="none"
                style={{
                  background: customerDisabled ? BACKGROUND_COLOR : '',
                  color: customerDisabled ? COLOR : '',
                  height: '99%',
                }}
              />}
              placeholder="Enter your phone number"
              customInput={Input}
            />
          </InputWrapper>
          <ErrorMessage
            errors={errors}
            name="phone"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
      </Row>
      <Hr />
      <AddressFields
        customInputStyle={customInputStyle}
        disableStyles={disableStyles}
        customSelectStyle={selectCustomStyles}
        errors={errors}
        control={control}
        watch={watch}
        trigger={trigger}
        register={register}
        setValue={setValue}
        BACKGROUND_COLOR={BACKGROUND_COLOR}
        preFillCustomer={preFillCustomer}
      />
      {alpha2 === 'IN' && <Hr className="mt-3" />}
      <IndiaFields
        errors={errors}
        control={control}
        alpha2={alpha2}
        customerValidation={false}
        isMobileView={isMobileView}
        customH2TextStyle={customH2TextStyle}
        customLabelTextStyle={customLabelTextStyle}
      />
      {alpha2 === 'IN' && <Hr className="mt-3" />}
      <Row>
        <Col span={24}>
          <H2Text {...customH2TextStyle}>SELECT BUSINESS</H2Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            Business Type
          </LabelText>
          <Controller
            defaultValue={""}
            color={errors.businessType ? "red" : "inherit"}
            marginBottom="0px"
            control={control}
            name="businessType"
            placeholder="select"
            rules={{
              required: 'Business type is required'
            }}
            as={<Select
              className="px-0 border-0"
              getOptionLabel={(option) => option.value}
              styles={selectCustomStyles}
              options={BUSINESS_TYPES_FUNDINGlINK.map(value => { return { value } }) } />}
          />
          <ErrorMessage
            errors={errors}
            name="businessType"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <label>
            <Controller
              marginBottom="0px"
              name='isDefault'
              control={control}
              render={({ field }) => (
                <Input
                  type="checkbox"
                  width="auto"
                  onChange={(e) => setValue('isDefault', e.target.checked)}
                />
              )}
            />
            <SpanText
              className="pl-2"
            >
              Set as default bank account
            </SpanText>
          </label>
        </Col>
      </Row>
      {isFBOReceiver && (
        <Row>
          <Col span={24}>
            <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              <Controller
                marginBottom="0px"
                name="receiptLimit"
                control={control}
                defaultValue={null}
                render={({ onChange, value }) => (
                  <Input
                    type="checkbox"
                    width="auto"
                    checked={value === 1}
                    onChange={(e) => {
                      const val = e.target.checked ? 1 : null;
                      onChange(val);
                      setValue('receiptLimit', val);
                    }}
                  />
                )}
              />
              <SpanText
                className="pl-2"
              >
                Can receive only once
              </SpanText>
            </label>
          </Col>
        </Row>
      )}
    </div>
  </>
  );
};

export default CommonFields;
